/*
 * @Description: 项目 store
 * @Author: lijinpeng
 * @Date: 2022-08-29 17:52:27
 * @LastEditTime: 2023-10-30 16:41:28
 * @LastEditors: WangYuhan
 */
// 引入api请求方法
import { getRouteListByBid } from '@/api/routeInfo';
import {
  postProjectPageList,
  getProjectListByBid,
  getProjectLeaderList,
  getProjectMemberList,
  projectExportUrl,
} from '@/api/project';

const storeModuleName = 'projectManageModule';
const state = {
  // 筛选项-
  parameters: [
    {
      style: 'select',
      param: 'businessId',
      isFixed: true,
      value: '',
      valueType: 'string',
      state: 'companyList',
      label: '企业',
      placeholder: '请选择',
      noMatchText: '无匹配企业',
      clearable: false,
      filterable: false,
      path: `${storeModuleName}/getCompanyList`,
    },
    {
      style: 'autocomplete',
      param: 'projectName',
      value: '',
      valueType: 'string',
      label: '项目名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getProjectList`,
    },
    {
      style: 'autocomplete',
      param: 'routeInfoName',
      value: '',
      valueType: 'string',
      label: '线路名称',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getRouteList`,
    },
    {
      style: 'autocomplete',
      param: 'leaderName',
      value: '',
      valueType: 'string',
      label: '负责人',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getLeaderList`,
    },
    {
      style: 'autocomplete',
      param: 'memberName',
      value: '',
      valueType: 'string',
      label: '项目成员',
      placeholder: '请输入',
      noMatchText: '无匹配请输入',
      clearable: true,
      filterable: false,
      path: `${storeModuleName}/getMemberList`,
    },
    {
      style: 'date-picker',
      param: 'createTime',
      value: [],
      valueType: 'date',
      label: '创建时间',
      placeholder: '请选择',
      type: 'daterange',
      format: 'MM-dd',
      valueFormat: 'yyyy-MM-dd',
      clearable: true,
      params: ['createStartTime', 'createEndTime'],
    },
    {
      style: 'input',
      param: 'creatorName',
      value: '',
      valueType: 'string',
      label: '创建人',
      placeholder: '请输入',
      clearable: true,
    },
  ],
  // tabs筛选项
  isSpecialTabs: false,
  isExport: {
    isShow: true,
    method: 'post',
    url: projectExportUrl,
  }, // 导出
  // 页码
  postParams: {
    page: 1,
    size: 20,
  },
  // 列表data数据
  listData: {
    list: [],
    tableHeadList: [
      {
        label: '企业名称',
        prop: 'businessName',
        width: 140,
        fixed: 'left',
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-businessName',
      },
      {
        label: '项目名称',
        prop: 'projectName',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-projectName',
      },
      {
        label: '关联线路',
        prop: 'relationRoute',
        width: 200,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-relationRoute',
        slotNameHeader: 'sub-header-relationRoute',
      },
      {
        label: '项目成员',
        prop: 'members',
        width: 170,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-members',
      },
      {
        label: '项目负责人',
        prop: 'leaderName',
        width: 100,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-leaderName',
      },
      {
        label: '创建时间',
        prop: 'createTime',
        width: 140,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-createTime',
      },
      {
        label: '操作',
        width: 80,
        checked: 1,
        sortable: true,
        slotName: 'sub-domain-operation',
      },
    ],
  },
  companyList: [], // 企业列表
  projectList: [], // 项目列表
  routeList: [], // 线路列表
  companyInfo: '', // 当前选中的企业信息
};

// getters
const getters = {};

// actions
const actions = {
  // 获取列表数据
  getList: async context => {
    const params = {};
    context.state.parameters.forEach(item => {
      if (item.style !== 'date-picker' && item.value) {
        params[item.param] = item.value;
      }
      if (item.style === 'date-picker' && item.value.length > 0) {
        params[item.params[0]] = `${item.value[0]} 00:00:00`;
        params[item.params[1]] = `${item.value[1]} 23:59:59`;
      }
    });
    var projectListHabits = {};
    const obj = Object.assign({}, context.state.postParams);
    if (obj.businessId || params.businessId) {
      projectListHabits.businessId = obj.businessId ? obj.businessId : params.businessId;
    }
    if (obj.projectId) {
      projectListHabits.projectId = obj.projectId;
    }
    if (obj.routeInfoId) {
      projectListHabits.routeInfoId = obj.routeInfoId;
    }
    localStorage.setItem('projectListHabits', JSON.stringify(projectListHabits));
    const { data } = await postProjectPageList(Object.assign({}, params, context.state.postParams));
    context.commit('updateState', {
      key: 'listData',
      value: Object.assign({}, context.state.listData, data),
    });
    return data.list;
  },
  // 获取企业列表
  getCompanyList: async (context, payload) => {
    const data = JSON.parse(localStorage.getItem('group'));
    if (data && data.id) {
      // 只展示实名认证的企业列表
      context.commit('updateState', {
        key: 'payPwdExist',
        value: data.payPwdExist,
      });
      context.commit('updateState', {
        key: 'payPwdStatus',
        value: data.payPwdStatus,
      });
      const list = data.corporations.filter(item => item.realNameAudit === 1);
      if (list.length) {
        list.forEach(item => {
          item.label = item.principalPartName;
          item.value = item.businessId;
        });
      }
      context.commit('updateState', {
        key: 'companyList',
        value: list,
      });
    }
  },
  // 获取项目列表
  getProjectList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectListByBid({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.name;
        });
        context.commit('updateState', {
          key: 'projectList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取线路列表
  getRouteList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getRouteListByBid({
        businessId: context.state.parameters[0].value,
        lineType: 'transfer',
        projectId: context.state.postParams.projectId,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.orderName;
        });
        context.commit('updateState', {
          key: 'routeList',
          value: data.list,
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取所有项目的负责人列表
  getLeaderList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectLeaderList({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.userName || item.userPhone;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
  // 获取所有项目的成员列表
  getMemberList: async (context, keyword) => {
    return new Promise(async (resolve, reject) => {
      const { code, data } = await getProjectMemberList({
        businessId: context.state.parameters[0].value,
        keyword,
      });
      if (code === 200) {
        data.list.forEach(item => {
          item.value = item.userName || item.userPhone;
        });
        resolve(data.list);
      } else {
        reject();
      }
    });
  },
};
// mutations
const mutations = {
  // 重置所有状态
  initFilter(state) {
    state.postParams = {
      page: 1,
      size: 20,
    };
    state.parameters.forEach(item => {
      if (item.isFixed) {
        return;
      }
      if (item.style !== 'date-picker' && item.value) {
        item.value = '';
      }
      if (item.style === 'date-picker') {
        item.value = [];
      }
    });
  },
  // 更新state数据
  updateState(state, { key, value }) {
    state[key] = value;
  },
  // 更新列表参数数据
  updatePostParams(state, payload) {
    state.postParams = Object.assign({}, state.postParams, payload);
  },
  // 根据index更新value
  updateValueFromIndex(state, payload) {
    console.log('updateValueFromIndex', payload.value);
    state.parameters[payload.index].value = payload.value;
    switch (state.parameters[payload.index].param) {
      case 'businessId':
        if (payload.from !== 1) {
          localStorage.removeItem('projectListHabits');
          localStorage.setItem(
            'projectListHabits',
            JSON.stringify({
              businessId: payload.value,
            }),
          );
        }
        state.companyInfo = state.companyList.find(item => item.businessId === payload.value);
        if (state.parameters[1].value) {
          state.parameters[1].value = '';
          state.postParams.projectId = '';
        }
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'projectName':
        state.postParams.projectId = payload.id;
        state.projectInfo = state.projectList.find(item => item.id === payload.id);
        if (state.parameters[2].value) {
          state.parameters[2].value = '';
          state.postParams.routeInfoId = '';
        }
        break;
      case 'routeInfoName':
        state.postParams.routeInfoId = payload.id;
        break;
      case 'leaderName':
        state.postParams.leaderId = payload.uid;
        break;
      case 'memberName':
        state.postParams.memberId = payload.uid;
        break;
      default:
        break;
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
